import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#b45309", amberBg: "#fffbeb", amberBorder: "#fde68a",
  red: "#dc2626", redBg: "#fef2f2", redBorder: "#fecaca",
  blue: "#2563eb", blueBg: "#eff6ff", blueBorder: "#bfdbfe",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:    <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:   <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    ShieldCheck:  <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    Shield:       <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>,
    AlertTriangle:<><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3z"/><path d="M12 9v4"/><path d="M12 17h.01"/></>,
    CheckCircle:  <><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></>,
    Clock:        <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    FileText:     <><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>,
    Camera:       <><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></>,
    MessageCircle:<><path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"/></>,
    Lock:         <><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
    Star:         <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    BadgeCheck:   <><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></>,
    Users:        <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    Wallet:       <><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></>,
    ChevronDown:  <><path d="m6 9 6 6 6-6"/></>,
    ChevronUp:    <><path d="m18 15-6-6-6 6"/></>,
    Eye:          <><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></>,
    XCircle:      <><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></>,
    Sparkles:     <><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3z"/></>,
    ThumbsUp:     <><path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88z"/></>,
    Info:         <><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ── FAQ accordion ── */
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", display: "flex", justifyContent: "space-between",
        alignItems: "center", padding: "20px 0", background: "none", border: "none",
        cursor: "pointer", fontFamily: T.sans, textAlign: "left", gap: 16,
      }}>
        <span style={{ fontSize: 15, fontWeight: 500, color: T.n800, lineHeight: 1.45, letterSpacing: "-0.01em" }}>{q}</span>
        <span style={{ flexShrink: 0, color: T.n400, transition: "transform .2s", display: "flex" }}>
          <Icon name={open ? "ChevronUp" : "ChevronDown"} size={18} strokeWidth={2} />
        </span>
      </button>
      <div style={{ overflow: "hidden", maxHeight: open ? 600 : 0, transition: "max-height .32s cubic-bezier(.4,0,.2,1)" }}>
        <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.8, margin: "0 0 20px", paddingRight: 32 }}>{a}</p>
      </div>
    </div>
  );
}

/* ── Policy card ── */
function PolicyCard({ icon, title, desc, severity }) {
  const severityStyle = {
    high:   { dot: T.red,   bg: T.redBg,   label: "Zero tolerance" },
    medium: { dot: T.amber, bg: T.amberBg, label: "Serious violation" },
    low:    { dot: T.blue,  bg: T.blueBg,  label: "Review required" },
  }[severity] || {};

  return (
    <div style={{
      padding: "22px", borderRadius: 14,
      border: `1px solid ${T.n150}`, background: T.white,
      display: "flex", flexDirection: "column", gap: 12,
    }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 10 }}>
        <div style={{ width: 38, height: 38, borderRadius: 10, background: T.n50, border: `1px solid ${T.n150}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <Icon name={icon} size={17} color={T.n600} strokeWidth={1.7} />
        </div>
        {severity && (
          <span style={{
            fontSize: 10, fontWeight: 700, letterSpacing: "0.06em",
            color: severityStyle.dot, background: severityStyle.bg,
            borderRadius: 99, padding: "3px 9px", whiteSpace: "nowrap",
          }}>
            {severityStyle.label}
          </span>
        )}
      </div>
      <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, letterSpacing: "-0.01em" }}>{title}</div>
      <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.75, margin: 0 }}>{desc}</p>
    </div>
  );
}

/* ── Step item ── */
function StepItem({ num, icon, title, desc, isLast }) {
  return (
    <div style={{ display: "flex", gap: 18, position: "relative" }}>
      {!isLast && (
        <div style={{ position: "absolute", left: 19, top: 44, bottom: -8, width: 1, background: `linear-gradient(to bottom, ${T.g200}, ${T.n150})` }} />
      )}
      <div style={{ width: 40, height: 40, borderRadius: "50%", background: T.g50, border: `1.5px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, zIndex: 1 }}>
        <Icon name={icon} size={16} color={T.g600} strokeWidth={1.8} />
      </div>
      <div style={{ flex: 1, paddingBottom: isLast ? 0 : 32 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 4 }}>Step {num}</div>
        <div style={{ fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 6, letterSpacing: "-0.01em" }}>{title}</div>
        <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.75, margin: 0 }}>{desc}</p>
      </div>
    </div>
  );
}

/* ── Guarantee tile ── */
function GuaranteeTile({ icon, title, body }) {
  return (
    <div style={{ padding: "24px", borderRadius: 14, border: `1px solid ${T.g100}`, background: T.g50, display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ width: 40, height: 40, borderRadius: 11, background: T.white, border: `1px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon name={icon} size={18} color={T.g500} strokeWidth={1.7} />
      </div>
      <div style={{ fontSize: 14, fontWeight: 600, color: T.g800, letterSpacing: "-0.01em" }}>{title}</div>
      <p style={{ fontSize: 13, color: T.g700, lineHeight: 1.75, margin: 0 }}>{body}</p>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function TrustSafetyPage() {
  useFonts();
  const navigate = useNavigate();

  const DISPUTE_STEPS = [
    {
      num: "01", icon: "FileText", title: "Open a report through the app",
      desc: "Go to Help and Support from your booking or account menu. Select the booking that had an issue and choose \"Report a problem.\" You do not need to know exactly which category it falls into -- just describe what happened.",
    },
    {
      num: "02", icon: "Camera", title: "Add evidence",
      desc: "Attach any photos, screenshots of messages, or other documentation that supports your account. The more specific your evidence, the faster and more accurately we can reach a fair decision. A photo of incomplete work is worth more than a description of it.",
    },
    {
      num: "03", icon: "Clock", title: "We review within 48 hours",
      desc: "Our Trust and Safety team reads every report. We contact the JiraniPro named in the dispute and give them the opportunity to share their side. Both accounts are considered before any decision is made. Most cases are resolved within 48 hours on business days.",
    },
    {
      num: "04", icon: "MessageCircle", title: "We contact you with an outcome",
      desc: "You receive a clear outcome through the app -- what we found, what action was taken, and whether a refund applies. If you disagree with the outcome, there is one round of appeal available. We document every case and track patterns across the platform.",
    },
  ];

  const POLICIES = [
    { icon: "XCircle",      title: "Not showing up without notice",          desc: "A JiraniPro who accepts a booking and fails to arrive without cancelling in advance will receive a formal warning. Repeat occurrences result in suspension.", severity: "medium" },
    { icon: "AlertTriangle",title: "Requesting payment outside the platform", desc: "All payments must go through JiraniApp. Any professional who asks a client to pay directly in cash or via personal M-Pesa -- bypassing the platform -- is removed immediately.", severity: "high" },
    { icon: "Lock",         title: "Sharing client contact details",          desc: "Client phone numbers, addresses, and personal information must not be used for any purpose outside of fulfilling the booked service. Violation results in permanent removal.", severity: "high" },
    { icon: "Star",         title: "Fake reviews or review manipulation",     desc: "Professionals who attempt to solicit, buy, or otherwise manipulate their review score are removed from the platform. Reviews must reflect genuine completed bookings.", severity: "high" },
    { icon: "Eye",          title: "Misrepresenting qualifications",          desc: "Professionals who claim certifications or experience they do not have -- particularly in regulated trades like electrical or gas plumbing -- are removed and reported where legally required.", severity: "high" },
    { icon: "Users",        title: "Harassment or threatening behaviour",     desc: "Any client or professional who threatens, harasses, or intimidates the other party through the platform will be removed immediately. We have zero tolerance for this.", severity: "high" },
    { icon: "Wallet",       title: "Charging more than the agreed rate",      desc: "The price confirmed at booking is the price. Any professional who charges above the agreed amount without the client's explicit consent before the work is done is in breach of platform rules.", severity: "medium" },
    { icon: "Camera",       title: "Damage to client property",               desc: "Accidental damage during a job must be reported to both the client and JiraniApp immediately. Deliberate damage or attempts to conceal damage result in immediate suspension pending investigation.", severity: "high" },
  ];

  const FAQS = [
    {
      q: "What counts as grounds for a dispute?",
      a: "Any situation where a service was not delivered as agreed: poor or incomplete work, a professional who did not arrive, a charge that was higher than the booking amount, damage to property, or any behaviour that felt threatening or inappropriate. You do not need to be certain before opening a report -- describe what happened and we will assess it.",
    },
    {
      q: "How long do I have to report a problem?",
      a: "Reports must be submitted within 48 hours of the job being marked complete. After this window, we have limited ability to investigate or reverse payments. If you noticed an issue after the 48-hour mark, still report it -- we may still be able to act, particularly for serious safety concerns.",
    },
    {
      q: "What happens to my payment while a dispute is open?",
      a: "If you opened a dispute before confirming job completion, your payment remains held and is not released to the JiraniPro until the case is resolved. If the job was already confirmed complete, we review whether a partial or full refund is warranted based on the evidence.",
    },
    {
      q: "Can I get a refund?",
      a: "Yes, in cases where the evidence supports it. Refunds are issued for: work that was not started, work that was significantly incomplete compared to what was agreed, and situations where the JiraniPro was clearly at fault. Partial refunds are common in cases of disputed quality. We do not issue refunds based on preference alone -- there needs to be a clear gap between what was agreed and what was delivered.",
    },
    {
      q: "What if I feel unsafe?",
      a: "If you feel your personal safety is at risk during or after a booking, contact emergency services first. Then report the incident through the app immediately using the safety flag option. Our Trust and Safety team treats all safety reports as the highest priority and responds within hours, not days.",
    },
    {
      q: "Will the JiraniPro know I reported them?",
      a: "The JiraniPro is informed that a dispute has been opened and is given the opportunity to respond. They are not given your contact details or told the specific content of any private messages you send to our team. The investigation is conducted by JiraniApp, not between you and the professional directly.",
    },
    {
      q: "What if I disagree with the outcome?",
      a: "You can request one appeal within five business days of receiving your outcome. Submit your appeal through the same Help and Support section with any additional evidence or context you want considered. A different member of the Trust and Safety team reviews the appeal independently.",
    },
    {
      q: "Does making a report affect my account?",
      a: "No. Making a good-faith report has no negative effect on your account. Clients are never penalised for raising legitimate concerns. We do track the overall dispute rate across the platform to identify patterns -- that data is used to improve, not to disadvantage clients who report issues.",
    },
  ];

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900 }}>
      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "none", border: "none", cursor: "pointer", color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0 }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/pro/support")} style={{
          display: "inline-flex", alignItems: "center", gap: 7,
          background: T.g500, color: T.white, border: "none",
          padding: "9px 18px", borderRadius: 9, fontSize: 13,
          fontWeight: 600, fontFamily: T.sans, cursor: "pointer",
        }}
          onMouseEnter={e => e.currentTarget.style.background = T.g600}
          onMouseLeave={e => e.currentTarget.style.background = T.g500}>
          <Icon name="AlertTriangle" size={13} color={T.white} strokeWidth={2.2} />
          Report a problem
        </button>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(56px,8vw,100px) 20px clamp(48px,6vw,76px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 24 }}>
            <Icon name="ShieldCheck" size={14} color={T.g500} strokeWidth={2.2} />
            Trust and Safety
          </div>
          <h1 style={{ fontFamily: T.serif, fontSize: "clamp(40px,7.5vw,70px)", fontWeight: 400, margin: "0 0 22px", lineHeight: 1.04, color: T.n900, letterSpacing: "-0.03em", maxWidth: 640 }}>
            You are protected<br/>
            on every booking<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>we are serious about that</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.8, margin: "0 0 36px", maxWidth: 520 }}>
            Every professional on JiraniApp is identity-verified before they can take bookings.
            Every payment is held securely until you confirm the work is done.
            If something goes wrong, there is a clear process and a real team to resolve it.
          </p>
          <button onClick={() => navigate("/pro/support")} style={{
            display: "inline-flex", alignItems: "center", gap: 8,
            background: T.g500, color: T.white, border: "none",
            padding: "15px 30px", borderRadius: 11, fontSize: 15, fontWeight: 600,
            cursor: "pointer", fontFamily: T.sans, letterSpacing: "0.01em",
          }}
            onMouseEnter={e => e.currentTarget.style.background = T.g600}
            onMouseLeave={e => e.currentTarget.style.background = T.g500}>
            Report an issue
            <Icon name="ArrowRight" size={16} color={T.white} strokeWidth={2} />
          </button>
        </div>
      </div>

      {/* ══ GUARANTEE STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}`, padding: "0 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
          {[
            { icon: "BadgeCheck", label: "Every Pro is ID-verified",        sub: "before their first booking" },
            { icon: "Lock",       label: "Payment held until job complete",  sub: "released only when you confirm" },
            { icon: "Clock",      label: "Disputes resolved in 48 hours",    sub: "on business days" },
          ].map(({ icon, label, sub }, i) => (
            <div key={i} style={{ padding: "22px 16px", display: "flex", alignItems: "flex-start", gap: 12, borderRight: i < 2 ? `1px solid ${T.n100}` : "none" }}>
              <Icon name={icon} size={18} color={T.g500} strokeWidth={1.6} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: T.n800, lineHeight: 1.35, marginBottom: 2 }}>{label}</div>
                <div style={{ fontSize: 12, color: T.n400 }}>{sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px clamp(80px,10vw,120px)" }}>

        {/* ══ HOW WE PROTECT YOU ══ */}
        <div style={{ paddingTop: "clamp(48px,7vw,64px)", marginBottom: "clamp(48px,7vw,64px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>The Jirani Guarantee</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,38px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            What we guarantee<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>on every booking</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            These are not aspirations. They are commitments we hold ourselves to on every job completed through the platform.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: 12 }}>
            <GuaranteeTile icon="BadgeCheck" title="Verified identity"
              body="Every JiraniPro has submitted a valid national ID or passport that our team has reviewed before they go live. You know the person coming to your home is who they say they are." />
            <GuaranteeTile icon="Lock" title="Secure payment"
              body="Your M-Pesa payment is held on the platform and only released to the JiraniPro once you mark the job complete. If the work is not done, your money does not move." />
            <GuaranteeTile icon="Star" title="Verified reviews only"
              body="Every review on a JiraniPro profile is tied to a real, completed booking. There are no anonymous ratings, no purchased reviews, and no way to review a Pro you have not actually booked." />
            <GuaranteeTile icon="Shield" title="Dispute protection"
              body="If something goes wrong, you have 48 hours after job completion to open a dispute. Our team reviews every case independently and does not simply default to the professional." />
            <GuaranteeTile icon="Eye" title="No off-platform pressure"
              body="JiraniPros are prohibited from asking you to pay in cash or contact them outside the app. If any professional pressures you to take the transaction off-platform, report it immediately." />
            <GuaranteeTile icon="ThumbsUp" title="Refunds where warranted"
              body="We issue partial or full refunds in cases where work was not completed as agreed. We document our refund decisions and apply them consistently across all disputes." />
          </div>
        </div>

        {/* ══ BEFORE YOUR BOOKING ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,64px)", padding: "clamp(28px,5vw,40px)", borderRadius: 18, background: T.n50, border: `1px solid ${T.n150}` }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Before the Pro arrives</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(22px,3.5vw,30px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Five things to check<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>before you let anyone in</em>
          </h2>
          <p style={{ fontSize: 14, color: T.n400, margin: "0 0 24px", lineHeight: 1.65 }}>
            Verification protects you before the job starts. These steps take less than a minute.
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {[
              { label: "Check the Verified badge",           body: "Every JiraniPro who has completed identity verification shows a green Verified badge on their profile. If it is not there, their verification may still be pending." },
              { label: "Read at least the last five reviews", body: "Reviews are tied to real bookings. Look for patterns in what previous clients say -- about punctuality, quality, and communication. A single bad review in 40 is different from three in a row." },
              { label: "Confirm the booking through the app", body: "Never agree to a booking or payment outside of JiraniApp. Your booking confirmation in the app is your record and your protection. Off-platform agreements are not covered by the Jirani Guarantee." },
              { label: "Check the Pro's response rate",       body: "Pros with a high response and acceptance rate have shown up consistently for other clients. This is shown on their profile and is a reliable signal of reliability." },
              { label: "Save the booking reference",          body: "Your booking reference number is visible in the app. Keep it accessible in case you need to raise a dispute. You will be asked for it." },
            ].map((item, i) => (
              <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start", padding: "16px 0", borderBottom: i < 4 ? `1px solid ${T.n100}` : "none" }}>
                <div style={{ width: 24, height: 24, borderRadius: "50%", background: T.white, border: `1.5px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1 }}>
                  <span style={{ fontSize: 11, fontWeight: 700, color: T.g600 }}>{i + 1}</span>
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n800, marginBottom: 4, letterSpacing: "-0.01em" }}>{item.label}</div>
                  <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.75, margin: 0 }}>{item.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ══ HOW DISPUTES WORK ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,64px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Raising a dispute</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,38px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Something went wrong.<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>Here is exactly what to do</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 32px", lineHeight: 1.65 }}>
            You have 48 hours from job completion to open a dispute. The process is straightforward.
            You do not need a lawyer. You do not need to confront anyone. Just describe what happened.
          </p>
          <div style={{ paddingLeft: 4 }}>
            {DISPUTE_STEPS.map((step, i) => (
              <StepItem key={i} {...step} isLast={i === DISPUTE_STEPS.length - 1} />
            ))}
          </div>

          {/* CTA */}
          <div style={{ marginTop: 36, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
            <button onClick={() => navigate("/pro/support")} style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: T.g500, color: T.white, border: "none",
              padding: "13px 26px", borderRadius: 10, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans, letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Open a report now
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <span style={{ fontSize: 13, color: T.n400 }}>Reviewed within 48 hours on business days</span>
          </div>
        </div>

        {/* ══ WHAT IS AGAINST THE RULES ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,64px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Platform rules</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,38px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            What JiraniPros are<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>never allowed to do</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 24px", lineHeight: 1.65 }}>
            These are the behaviours that result in immediate action against a professional's account.
            If you experience any of these, report it through the app right away.
          </p>

          {/* Severity legend */}
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 20 }}>
            {[
              { dot: T.red,   label: "Zero tolerance -- immediate removal" },
              { dot: T.amber, label: "Serious violation -- formal warning or suspension" },
            ].map(({ dot, label }, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 7 }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: dot, flexShrink: 0 }} />
                <span style={{ fontSize: 12, color: T.n500 }}>{label}</span>
              </div>
            ))}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 12 }}>
            {POLICIES.map((p, i) => <PolicyCard key={i} {...p} />)}
          </div>
        </div>

        {/* ══ FAQ ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,64px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Common questions</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,38px)", fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Before you <em style={{ fontStyle: "italic", color: T.g600 }}>raise a dispute</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 8px", lineHeight: 1.65 }}>
            Straightforward answers to what clients ask most.
          </p>
          <div style={{ marginTop: 8 }}>
            {FAQS.map((f, i) => <FaqItem key={i} {...f} />)}
          </div>
        </div>

        {/* ══ SAFETY WARNING CALLOUT ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,64px)", padding: "24px 26px", borderRadius: 14, background: T.redBg, border: `1.5px solid ${T.redBorder}`, display: "flex", gap: 16, alignItems: "flex-start" }}>
          <div style={{ width: 38, height: 38, borderRadius: 10, background: T.white, border: `1px solid ${T.redBorder}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Icon name="AlertTriangle" size={18} color={T.red} strokeWidth={1.8} />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: T.red, marginBottom: 6, letterSpacing: "-0.01em" }}>If you feel unsafe right now</div>
            <p style={{ fontSize: 14, color: "#991b1b", lineHeight: 1.75, margin: "0 0 12px" }}>
              If you are in immediate danger, call 999 or 112 first. Then open the app and use the safety flag on your booking to alert our team. We treat all personal safety reports as the highest priority and respond within hours.
            </p>
            <button onClick={() => navigate("/pro/support")} style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              background: "none", border: "none", cursor: "pointer",
              color: T.red, fontSize: 13, fontWeight: 700,
              fontFamily: T.sans, padding: 0, letterSpacing: "-0.01em",
            }}>
              Flag a safety concern in the app
              <Icon name="ArrowRight" size={13} color={T.red} strokeWidth={2.5} />
            </button>
          </div>
        </div>

        {/* ══ FOOTER CTA ══ */}
        <div style={{ padding: "clamp(36px,5vw,52px)", borderRadius: 20, border: `1px solid ${T.g100}`, textAlign: "center", background: T.g50 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: T.white, border: `1.5px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icon name="ShieldCheck" size={22} color={T.g500} strokeWidth={1.6} />
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Had an issue with a booking?<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>We are here to fix it</em>
          </h2>
          <p style={{ fontFamily: T.sans, fontSize: 15, color: T.n600, margin: "0 auto 28px", lineHeight: 1.75, maxWidth: 400 }}>
            Open a report through Help and Support. Describe what happened. Our team will review it and get back to you within 48 hours.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => navigate("/pro/support")} style={{
              padding: "14px 32px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Open Help and Support
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/how-it-works")} style={{
              padding: "14px 28px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
              How JiraniApp works
            </button>
          </div>
          <p style={{ fontSize: 12, color: T.n300, margin: "20px 0 0" }}>
            Reviewed within 48 hours on business days · Every report is read by a human
          </p>
        </div>

      </div>
    </div>
  );
}